import { createFileRoute } from '@tanstack/react-router';

import {
  audienceSummaryQueryOptions,
  audienceTrendQueryOptions,
  fansQueryOptions,
} from '@/features/audience/api';
import { AudiencePage } from '@/features/audience/components/audience-page';
import { audienceSearchSchema, audienceTrendParams } from '@/features/audience/search';

export const Route = createFileRoute('/_app/audience')({
  validateSearch: audienceSearchSchema,
  loaderDeps: ({ search }) => search,
  staticData: { title: '팔로워 · 구독자', group: '통계' },
  loader: ({ context: { queryClient }, deps }) => {
    // 추이·팬 목록은 기다리지 않는다 — 조건을 바꿀 때 화면 전체가 로딩으로 바뀌지 않고 카드 안에서만 갱신된다
    const trend = audienceTrendParams(deps);
    void queryClient
      .query(audienceTrendQueryOptions({ unit: trend.unit, from: trend.from }))
      .catch(() => undefined);
    void queryClient
      .query(fansQueryOptions({ sort: deps.sort, page: deps.page }))
      .catch(() => undefined);
    return queryClient.query({ ...audienceSummaryQueryOptions(), staleTime: 'static' });
  },
  head: () => ({ meta: [{ title: '팔로워 · 구독자 · 팬즈드롭 파트너' }] }),
  component: AudienceRoute,
});

function AudienceRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <AudiencePage
      search={search}
      onSearchChange={next => {
        void navigate({
          search: previous => ({ ...previous, ...next }),
          replace: true,
          resetScroll: false,
        });
      }}
    />
  );
}
